module.exports = __webpack_public_path__ + "img/default_member_group.8fe098eb.svg";